/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

(function () {
  var WISHLIST_KEY = 'bg-wishlist';

  function getWishlist() {
    try {
      return JSON.parse(window.localStorage.getItem(WISHLIST_KEY) || '[]');
    } catch (error) {
      return [];
    }
  }

  function setWishlist(items) {
    window.localStorage.setItem(WISHLIST_KEY, JSON.stringify(items));
  }

  function getCurrentProductData() {
    var dataNode = document.querySelector('[data-product-json]');

    if (!dataNode) {
      return null;
    }

    try {
      return JSON.parse(dataNode.textContent);
    } catch (error) {
      return null;
    }
  }

  function getSelectedVariant(productData) {
    if (!productData || !productData.product || !productData.product.variants) {
      return null;
    }

    var variantId = productData.selected_variant_id;

    return productData.product.variants.find(function (variant) {
      return variant.id === variantId;
    }) || productData.product.variants[0] || null;
  }

  function buildWishlistItem(productData) {
    var product = productData.product;
    var variant = getSelectedVariant(productData);
    var image = variant && variant.featured_image ? variant.featured_image : (product.images && product.images[0]);

    return {
      id: variant ? String(variant.id) : String(product.id),
      productId: String(product.id),
      title: product.title,
      url: product.url,
      price: variant ? variant.price : product.price,
      variantTitle: variant && variant.title !== 'Default Title' ? variant.title : '',
      image: image && image.src ? image.src : image
    };
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
  }

  function updateWishlistUi() {
    var items = getWishlist();
    var counts = document.querySelectorAll('.Header__WishlistCount');
    var dots = document.querySelectorAll('.Header__WishlistDot');
    var drawer = document.querySelector('[data-wishlist-drawer]');

    Array.prototype.forEach.call(counts, function (count) {
      count.textContent = items.length;
    });

    Array.prototype.forEach.call(dots, function (dot) {
      dot.classList.toggle('is-visible', items.length > 0);
    });

    if (drawer) {
      if (!items.length) {
        drawer.innerHTML = '<p class="WishlistDrawer__Empty Heading u-h6">Your wishlist is empty.</p>';
      } else {
        drawer.innerHTML = '<div class="WishlistDrawer__List">' + items.map(function (item) {
          return (
            '<div class="WishlistDrawer__Item">' +
              '<a class="WishlistDrawer__Image" href="' + item.url + '">' +
                '<img src="' + item.image + '" alt="' + item.title.replace(/"/g, '&quot;') + '">' +
              '</a>' +
              '<div>' +
                '<a class="WishlistDrawer__Title Heading Link Link--primary u-h7" href="' + item.url + '">' + item.title + '</a>' +
                '<div class="WishlistDrawer__Meta Text--subdued">' + (item.variantTitle ? item.variantTitle + ' · ' : '') + formatMoney(item.price) + '</div>' +
                '<button type="button" class="WishlistDrawer__Remove Link Link--secondary" data-wishlist-remove="' + item.id + '">Remove</button>' +
              '</div>' +
            '</div>'
          );
        }).join('') + '</div>';
      }
    }

    var button = document.querySelector('.ProductForm__WishlistButton');
    var floatingButton = document.querySelector('.Product__WishlistButton');
    var productData = getCurrentProductData();

    if (button && productData) {
      var currentItem = buildWishlistItem(productData);
      var isActive = items.some(function (item) { return item.id === currentItem.id; });

      button.classList.toggle('is-active', isActive);
      button.textContent = isActive ? 'Added to wishlist' : 'Add to wishlist';
    }

    if (floatingButton && productData) {
      var floatingItem = buildWishlistItem(productData);
      var floatingIsActive = items.some(function (item) { return item.id === floatingItem.id; });

      floatingButton.classList.toggle('is-active', floatingIsActive);
      floatingButton.setAttribute('aria-label', floatingIsActive ? 'Added to wishlist' : 'Add to wishlist');
    }
  }

  function ensureWishlistButton() {
    var addToCartButton = document.querySelector('.ProductForm__AddToCart');
    var productData = getCurrentProductData();

    if (!addToCartButton || !productData || document.querySelector('.ProductForm__WishlistButton')) {
      return;
    }

    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'ProductForm__WishlistButton Link Link--secondary';
    addToCartButton.insertAdjacentElement('afterend', button);
    updateWishlistUi();
  }

  function openWishlistDrawer(event) {
    var drawer = document.getElementById('sidebar-wishlist');
    var overlay = document.querySelector('.PageOverlay');

    if (!drawer) {
      return;
    }

    if (event) {
      event.preventDefault();
    }

    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('no-scroll');

    if (overlay) {
      overlay.classList.add('is-visible');
    }
  }

  function closeWishlistDrawer(event) {
    var drawer = document.getElementById('sidebar-wishlist');
    var overlay = document.querySelector('.PageOverlay');

    if (!drawer) {
      return;
    }

    if (event) {
      event.preventDefault();
    }

    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('no-scroll');

    if (overlay) {
      overlay.classList.remove('is-visible');
    }
  }

  function replaceJapaneseWishlistLabels(scope) {
    var root = scope || document;
    var nodes = root.querySelectorAll('a, button, span, div, p');

    Array.prototype.forEach.call(nodes, function (node) {
      if (!node.textContent || node.textContent.indexOf('お気に入り') === -1) {
        return;
      }

      var target = node.closest('a, button, .wk-button, .swym-button, .wishlist-hero-custom, .product-form__item, div, p') || node;

      if (target && !target.classList.contains('ProductForm__WishlistButton')) {
        target.style.display = 'none';
      }
    });
  }

  function observeJapaneseWishlistLabels() {
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        Array.prototype.forEach.call(mutation.addedNodes || [], function (node) {
          if (node.nodeType === 1) {
            replaceJapaneseWishlistLabels(node);
          }
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  function createAccordionItem(title, contentHtml, expanded) {
    return (
      '<div class="Collapsible Collapsible--large">' +
        '<button class="Collapsible__Button Heading u-h6" data-action="toggle-collapsible" aria-expanded="' + (expanded ? 'true' : 'false') + '">' +
          title +
          ' <span class="Collapsible__Plus"></span>' +
        '</button>' +
        '<div class="Collapsible__Inner"' + (expanded ? ' style="height: auto; overflow: visible;"' : '') + '>' +
          '<div class="Collapsible__Content">' +
            '<div class="Rte">' + contentHtml + '</div>' +
          '</div>' +
        '</div>' +
      '</div>'
    );
  }

  function transformProductDescription(scope) {
    var root = scope || document;
    var descriptions = root.querySelectorAll('.ProductMeta__Description');

    Array.prototype.forEach.call(descriptions, function (description) {
      if (description.getAttribute('data-accordionized') === 'true') {
        return;
      }

      var rte = description.querySelector('.Rte');

      if (!rte) {
        return;
      }

      var children = Array.prototype.slice.call(rte.children);

      if (!children.length) {
        return;
      }

      var sections = [];
      var currentSection = {
        title: 'Description',
        html: ''
      };

      children.forEach(function (child) {
        if (/^H[1-6]$/.test(child.tagName)) {
          if (currentSection.html.trim() !== '') {
            sections.push(currentSection);
          }

          currentSection = {
            title: child.textContent.trim(),
            html: ''
          };
        } else {
          currentSection.html += child.outerHTML;
        }
      });

      if (currentSection.html.trim() !== '') {
        sections.push(currentSection);
      }

      if (!sections.length) {
        return;
      }

      var accordionHtml = '<div class="Product__Tabs Product__Tabs--generated">';

      sections.forEach(function (section, index) {
        accordionHtml += createAccordionItem(section.title, section.html, index === 0);
      });

      accordionHtml += '</div>';

      description.innerHTML = accordionHtml;
      description.setAttribute('data-accordionized', 'true');
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    transformProductDescription(document);
    ensureWishlistButton();
    replaceJapaneseWishlistLabels();
    updateWishlistUi();
    observeJapaneseWishlistLabels();
  });

  document.addEventListener('shopify:section:load', function (event) {
    transformProductDescription(event.target);
    ensureWishlistButton();
    replaceJapaneseWishlistLabels();
    updateWishlistUi();
  });

  document.addEventListener('variant:changed', function (event) {
    var productData = getCurrentProductData();

    if (productData && event.detail && event.detail.variant) {
      productData.selected_variant_id = event.detail.variant.id;
      updateWishlistUi();
    }
  });

  document.addEventListener('click', function (event) {
    var closeWishlistButton = event.target.closest('[data-action="close-drawer"][data-drawer-id="sidebar-wishlist"]');
    var openWishlistTrigger = event.target.closest('[data-action="open-drawer"][data-drawer-id="sidebar-wishlist"]');
    var wishlistButton = event.target.closest('.ProductForm__WishlistButton, .Product__WishlistButton');
    var removeButton = event.target.closest('[data-wishlist-remove]');
    var overlay = event.target.closest('.PageOverlay');

    if (closeWishlistButton) {
      closeWishlistDrawer(event);
      return;
    }

    if (openWishlistTrigger) {
      openWishlistDrawer(event);
      return;
    }

    if (overlay && document.getElementById('sidebar-wishlist') && document.getElementById('sidebar-wishlist').getAttribute('aria-hidden') === 'false') {
      closeWishlistDrawer(event);
      return;
    }

    if (wishlistButton) {
      var productData = getCurrentProductData();

      if (!productData) {
        return;
      }

      var item = buildWishlistItem(productData);
      var items = getWishlist();
      var existingIndex = items.findIndex(function (entry) { return entry.id === item.id; });

      if (existingIndex === -1) {
        items.unshift(item);
      } else {
        items.splice(existingIndex, 1);
      }

      setWishlist(items);
      updateWishlistUi();
    }

    if (removeButton) {
      var itemId = removeButton.getAttribute('data-wishlist-remove');
      var nextItems = getWishlist().filter(function (item) { return item.id !== itemId; });

      setWishlist(nextItems);
      updateWishlistUi();
    }
  });
})();
